import { Component, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BudgetManager } from '../../../model/api/assets/budget-manager';
import { PagedResult } from '../../../model/common/paged-result';
import { Param } from '../../../model/common/param';
import { BudgetManagerHttpService } from '../../../services/http/administration/budget-manager.http.service';
import { GenericManage } from '../../generic/generic.manage'; 


@Component({
    selector: 'budget-manager-manage',
    templateUrl: 'budget-manager.manage.html',
    providers: []
})
export class BudgetManagerManage extends GenericManage<BudgetManager, number> {

     @ViewChild('itemDetailModal') modal: ModalDirective;

    public filter: string = '';
    isCollapsed: boolean = true;

    constructor(public budgetManagerHttpService: BudgetManagerHttpService) {
        super();
    }

     public detailInitialize() {
        this.modal.show();
    }

    public detailTerminate() {
        this.modal.hide();
    }

    public exportToExcel() {

        let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.budgetManagerHttpService.get(1, 1000000, 'name', 'asc', params, null).subscribe(
            (data: PagedResult<BudgetManager>) => {

                let options = {
                    sheetid: 'centre_logistice',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // alasql(`SELECT id as [Id], 
                //     name as [Denumire] 
                //     INTO XLSX("centre_logistice.xlsx",?) FROM ?`, [ options, data.items ]);

            });
    }

    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
